function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.13 9.798a.146.146 0 0 0-.205 0l-2.118 2.118c-.981.98-2.636 1.085-3.719 0-1.085-1.085-.98-2.738 0-3.719L4.206 6.08a.146.146 0 0 0 0-.206l-.725-.726a.146.146 0 0 0-.206 0L1.157 7.266a3.941 3.941 0 0 0 0 5.578 3.942 3.942 0 0 0 5.578 0l2.118-2.118a.146.146 0 0 0 0-.206l-.722-.722zm4.715-8.641a3.94 3.94 0 0 0-5.578 0l-2.12 2.118a.146.146 0 0 0 0 .206l.724.724c.056.056.149.056.205 0l2.119-2.119c.98-.98 2.636-1.084 3.718 0 1.085 1.085.981 2.739 0 3.72L9.795 7.923a.146.146 0 0 0 0 .206l.726.725c.056.057.15.057.206 0l2.118-2.118a3.947 3.947 0 0 0 0-5.58zM8.789 4.455a.146.146 0 0 0-.206 0L4.454 8.582a.146.146 0 0 0 0 .206l.722.722c.057.056.15.056.206 0l4.127-4.128a.146.146 0 0 0 0-.206l-.72-.721z",
  fill: "#fff"
});

var SvgIntegration = function SvgIntegration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Integration.6631725a.svg";
export { ForwardRef as ReactComponent };